import Br11 from "./6.png";
import Br12 from "./7.png";
import Br13 from "./8.png";
import Br14 from "./9.png";

const br1images = [Br11, Br12, Br13, Br14];

export default br1images;
